import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSideBar = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.5 16.4908C11.0191 16.5 10.4696 16.5 9.83333 16.5H8.16667C5.83311 16.5 4.66634 16.5 3.77504 16.0459C2.99103 15.6464 2.35361 15.009 1.95414 14.225C1.5 13.3337 1.5 12.1669 1.5 9.83333V8.16667C1.5 5.83311 1.5 4.66634 1.95414 3.77504C2.35361 2.99103 2.99103 2.35361 3.77504 1.95414C4.66634 1.5 5.83311 1.5 8.16667 1.5H9.83333C10.4696 1.5 11.0191 1.5 11.5 1.50921M11.5 16.4908C12.7827 16.4662 13.5767 16.3762 14.225 16.0459C15.009 15.6464 15.6464 15.009 16.0459 14.225C16.5 13.3337 16.5 12.1669 16.5 9.83333V8.16667C16.5 5.83311 16.5 4.66634 16.0459 3.77504C15.6464 2.99103 15.009 2.35361 14.225 1.95414C13.5767 1.62383 12.7827 1.53376 11.5 1.50921M11.5 16.4908L11.5 1.50921M5.25 6.5C6.16368 7.16379 6.98205 7.94192 7.68388 8.81383C7.77204 8.92336 7.77204 9.07664 7.68388 9.18617C6.98205 10.0581 6.16368 10.8362 5.25 11.5",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSideBar);
export default ForwardRef;
